"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _bindTag = _interopRequireDefault(require("../lists/bindTag.vue"));
var _logDetail = _interopRequireDefault(require("./logDetail.vue"));
var mealOrderApi = _interopRequireWildcard(require("@/api/mealOrderApi"));
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'thirdOrderDetail',
  components: {
    BindTag: _bindTag.default,
    LogDetail: _logDetail.default
  },
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      orderDatalist: {},
      loading: false,
      baseOption: [
      // 订单基础信息
      {
        title: '订单编号',
        dataIndex: 'orderNo'
      }, {
        title: '客户单号',
        dataIndex: 'outTradeNo'
      }, {
        title: '产品名称',
        dataIndex: 'productName'
      }, {
        title: '客户名称',
        dataIndex: 'customerName'
      }, {
        title: '客户扣费',
        dataIndex: 'customerAmount'
      }, {
        title: '订单金额',
        dataIndex: 'orderPrice'
      }, {
        title: '销售商扣费',
        dataIndex: 'settleAmount'
      }, {
        title: '订单状态',
        dataIndex: 'statusName'
      }, {
        title: '供应商名称',
        dataIndex: 'supplierName'
      }, {
        title: '订单更新时间',
        dataIndex: 'updateTime'
      }],
      orderNo: null,
      needRefreshList: 0 // 关闭时是否需要刷新列表 0:不需要 1:需要
    };
  },
  mounted: function mounted() {},
  methods: {
    transformState: _transformState.default,
    openDetail: function openDetail(orderNo) {
      this.orderNo = orderNo;
      this.needRefreshList = 0;
      if (!orderNo) {
        this.$message.warning('未查询到该订单！');
        return;
      }
      this.getOrderData();
    },
    // 获取订单物流信息
    getOrderData: function getOrderData() {
      var _this = this;
      var needRefreshList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.needRefreshList = needRefreshList;
      this.dialogVisible = true;
      this.loading = true;
      mealOrderApi.mealOrderDetial(this.orderNo).then(function (res) {
        _this.orderDatalist = res || {};
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    // 关闭弹窗，判断是否需要刷新列表
    handleColse: function handleColse() {
      this.needRefreshList == 1 && this.$emit('doRefresh');
      this.dialogVisible = false;
    },
    // 查看日志详情
    openReqDetail: function openReqDetail(row) {
      this.$refs['LogDetailRef'].openInit(row);
    },
    syncMealStatus: function syncMealStatus() {
      var _this2 = this;
      if (!this.orderNo) return;
      this.loading = true;
      orderListApi.syncMealStatus(this.orderNo).then(function (res) {
        _this2.loading = false;
        _this2.$message.success('同步成功！');
        _this2.getOrderData();
      }).catch(function (err) {
        _this2.loading = false;
      });
    }
  }
};